import {
  OrganizationalUnitDTO,
  MasterDataDTO,
  DivisionDTO,
  DocumentClassDTO,
  TaskDTO,
  IObjectDTO,
  FavouriteProjectDTO,
  PersonDTO,
  BaseObjectDTO
} from './plyca-dtos';
import { ServiceLocator } from '../ServiceLocator';
import { HelpService } from '../components/common/help/help.service';
import { FieldConfig } from './contract-notice-dto';
import { ContractDTO, ObjectContextDTO } from './plyca-dtos-v2';

export class BaseDivisionDTO {

  parent: DivisionDTO;
  children: DivisionDTO[];

  creationDate: Date;
  name: string;

  documentClass: DocumentClassDTO;
  type: MasterDataDTO;
  phase: MasterDataDTO;

}

// BaseProjectEntityDTO
export class BaseProjectEntityDTO extends BaseDivisionDTO {
  contractFolderId: string;

  startDate: Date;
  organizationalUnit: OrganizationalUnitDTO;
  opcProcedure: boolean;
  title: string;
  favourite: FavouriteProjectDTO;
  // DivisionDTO
  identifier: string;

  procedure: MasterDataDTO;
  usuid: string;

}

export class AnnuityAmountDTO {
  year: number;
  amount: number;
  concepts: Array<MasterDataDTO>;
}

export class OrderBudgetDTO {
  annuitiesAmount: Array<AnnuityAmountDTO>;
}

export class Coordination2DTO {

  // Coordinador Propuesta 2
  coordinator: PersonDTO;
}

export class OrderCoordinationDTO {
  commissionCoordinator: PersonDTO;
  // Coordinador Propuesta 1
  proposalCoordinator1: PersonDTO;
  // Listado de Coordinador Propuesta 2
  proposalCoordinatorClient: Array<Coordination2DTO>;

  proposalCoordinator2: Array<PersonDTO>;
}

export class OrderOrganizationalInfoDTO {
  area: OrganizationalUnitDTO;
  activity: MasterDataDTO;
  departmentChief: PersonDTO;
  areaChief: PersonDTO;
}


export class OrderProjectDTO extends BaseProjectEntityDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  context?: ObjectContextDTO;

  division: DivisionDTO;
  annuities: Array<number>;

  totalPem: number;
  totalAmountCorporateExpenses: number;
  totalConcepts: Array<MasterDataDTO>;

  orderBudget: OrderBudgetDTO;
  budgetaryBreakDownList: BugdetaryBreakdownDTO[];
  costBreakdownList: CostBreakdownDTO[];
  incomeBreakdownList: IncomeBreakdownDTO[];
  totalBreakdownList: TotalBreakdownDTO[];

  incomeConcepts: MasterDataDTO[];
  costConcepts: MasterDataDTO[];

  orderCoordination: OrderCoordinationDTO;
  organizationalInfo: OrderOrganizationalInfoDTO;

  budgetaryProjectRelated: BugdetaryBreakdownDTO;

  staffCategories: OrderPersonalInfoDTO[];
  staffWorkers: OrderPersonalInfoDTO[];

  plannedPeriod: OrderPlannedPeriodDTO;
}

export class OrderPlannedPeriodDTO {
  orderValidityFrom: Date;
  orderValidityUntil: Date;
  extension: number;
}

export class OrderPersonalInfoDTO {
  category: OrderCategoryDTO;
  procurementPercentage: number;
  boxSS: number;
  salaryUpdatePercentage: number;
  assignmentOrderPercentage: number;
  numbersPerson: number;
  annualSalary: number;
  totalAmount: number;
  person: OrderPersonDTO;

}

export class OrderPersonDTO {
  identifier: string;

}

export class OrderCategoryDTO {
  identifier: string;
  description: string;
  anualSalaryByCategory: number;
}

// Estructura auxiliar de cliente
export class AmountMonthsDTO {
  month: MasterDataDTO;
  amount: number;
  enabled: boolean;
}

export class CostBreakdownDTO {
  costConcept: MasterDataDTO;
  amountMonths: AmountMonthsDTO[];
  year: number;

}

export class IncomeBreakdownDTO {
  incomeConcept: MasterDataDTO;
  amountMonths: AmountMonthsDTO[];
  year: number;

}

export class TotalBreakdownDTO {
  totalConcept: MasterDataDTO;
  year: number;
  amountMonths: AmountMonthsDTO[];
  amount: number;
}

export class BugdetaryBreakdownDTO {
  year: number;
  creationDate: Date;
  modificationDate: Date;
  incomeBreakdownList: IncomeBreakdownDTO[];
  costBreakdownList: CostBreakdownDTO[];
  totalBreakdownList: TotalBreakdownDTO[];
  totalIncome: number;
  totalProduction: number;
  totalCost: number;
  grossMargin: number;
}

export class BudgetaryProjectDTO extends BaseProjectEntityDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  modificationDate: Date;
  area: OrganizationalUnitDTO;
  activity: MasterDataDTO;

  division: DivisionDTO;
  annuitiesList: Array<number>;
  incomeConcepts: MasterDataDTO[];
  costConcepts: MasterDataDTO[];
  costBreakdownList: CostBreakdownDTO[];
  incomeBreakdownList: IncomeBreakdownDTO[];
  totalBreakdownList: TotalBreakdownDTO[];


  budgetaryBreakDownList: BugdetaryBreakdownDTO[];
}

export class RelatedOrderProjectDTO {
  orderProject: OrderProjectDTO;
  contract: ContractDTO;
}

export interface WorkBudgetaryProjectDTO extends BaseObjectDTO<string> {
  identifier: string;
  budgetaryProject: BudgetaryProjectDTO;
  context?: ObjectContextDTO;
}

export interface WorkOrderProjectDTO extends BaseObjectDTO<string> {
  identifier: string;
  orderProject: OrderProjectDTO;
  context?: ObjectContextDTO;
}